'use client';

import { AuthProvider, type InitialAuth } from '@/lib/auth-context';
import { ReactNode } from 'react';

export function Providers({ children, initialAuth }: { children: ReactNode; initialAuth: InitialAuth }) {
  return (
    <AuthProvider initialAuth={initialAuth}>
      {children}
    </AuthProvider>
  );
}
